// extracted by mini-css-extract-plugin
export default {"dia":"greybox_dia__T+AoU","los1":"greybox_los1__NcSTr"};